import { defineComponent as _defineComponent } from 'vue'
import { AxiosError } from 'axios';
import { onMounted, ref } from 'vue';

import { AuditEntity } from '@extTypes/auditLog/types';
import { EntityVersionRestored, VersionInfo } from '@extTypes/versioning';
import { Settings } from '@extTypes/settings/settings';
import { OptionSetDto } from '@extTypes/options/optionSet';

import LoaderBtn from '@/components/LoaderBtn/LoaderBtn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RestoreEntityVersion',
  props: {
    entityId: null,
    entityType: null,
    entityName: null,
    getVersion: null,
    listVersions: null,
    restoreVersion: null
  },
  emits: ["go-back", "entity-version-restored"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'go-back'): void;
    (event: 'entity-version-restored', data: EntityVersionRestored): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    entityId?: string | number;
    entityType: AuditEntity;
    entityName: string;
    getVersion: (key: string, versionId: string) => Promise<Settings.Settings | OptionSetDto>;
    listVersions: (id: string | number) => Promise<VersionInfo[]>;
    restoreVersion: (data: Settings.Settings | OptionSetDto, id: string | number) => Promise<void>;
};





const version = ref('');
const saving = ref(false);
const loadingVersions = ref(false);
const errorMessage = ref('');
const versions = ref<VersionInfo[]>([]);

const goBack = () => {
    emit('go-back');
};

const restoreEntityVersion = async () => {
    if (!props.entityId) {
        errorMessage.value = 'No entity selected for restoration.';
        return;
    }
    try {
        saving.value = true;
        errorMessage.value = '';
        const selected = versions.value.find((v) => v.VersionId === version.value);
        if (!selected) return;

        const data = await props.getVersion(selected.Key, selected.VersionId);
        await props.restoreVersion(data, props.entityId);
        emit('entity-version-restored', { entityId: props.entityId, data });
    } catch (error) {
        const axiosError = error as AxiosError;
        errorMessage.value =
            axiosError.response?.data?.Message ?? `Error restoring version for ${parseEntity()} ${props.entityId}`;
    } finally {
        saving.value = false;
    }
};

const getEntityVersions = async () => {
    if (!props.entityId) {
        versions.value = [];
        return;
    }
    try {
        loadingVersions.value = true;
        versions.value = await props.listVersions(props.entityId);
    } catch (error) {
        console.error(error);
        errorMessage.value = 'Error loading versions';
    } finally {
        loadingVersions.value = false;
    }
};

const parseEntity = (): string => {
    switch (props.entityType) {
        case AuditEntity.LIBRARY:
            return 'Library';
        case AuditEntity.OPTION_SET:
            return 'Option Set';
        case AuditEntity.PRODUCT:
            return 'Product';
        case AuditEntity.TEMPLATE:
            return 'Template';
        case AuditEntity.SETTING:
            return 'Setting';
        default:
            return 'Unknown';
    }
};

onMounted(getEntityVersions);

return { __sfc: true,props, emit, version, saving, loadingVersions, errorMessage, versions, goBack, restoreEntityVersion, getEntityVersions, parseEntity, LoaderBtn }
}

})